const _ = require("lodash");

const getBookTestHashFromName = miscBlockName => {
	if (!miscBlockName || typeof miscBlockName !== "string") return null;
	if (!miscBlockName.startsWith("bookTest")) return null;
	return miscBlockName.slice(8);
};

const isBlockComplete = blockModel => {
	const {stars, starsObtained} = blockModel;
	return stars > 0 || starsObtained > 0;
};

const getFinishedBlocks = blockModels =>
	_.filter(blockModels, b => isBlockComplete(b));

const getUnfinishedBlocks = blockModels =>
	_.filter(blockModels, b => !isBlockComplete(b));

/**
 * First sort by release date in descending order, then sort by grade number,
 * chapter index, then block index in ascending order.
 * @param {Array} blockModels
 * @returns {Array} of sorted blocks
 */
const sortUnfinishedHomework = (blockModels, ignoreReleaseDate = false) =>
	blockModels.sort((a, b) => {
		if (a.releaseDate > b.releaseDate && !ignoreReleaseDate) return -1; // a first
		if (a.releaseDate < b.releaseDate && !ignoreReleaseDate) return 1; // b first
		const keysToSortBy = ["gradeNumber", "chapterIndex", "blockIndex"];
		for (const key of keysToSortBy) {
			// these go in ascending order, if releaseDate is identical
			if (key === "blockIndex") {
				// Handle null blockIndex values - put them at the end
				if (a[key] === null && b[key] === null) return 0;
				if (a[key] === null) return 1; // a goes after b
				if (b[key] === null) return -1; // b goes after a
			}
			if (a[key] !== b[key]) {
				// these are all numerical
				return a[key] - b[key];
			}
		}
		return 0; // in theory we never reach this, since blockIndex should be unique
	});

const sortFinishedHomework = blockModels =>
	_.reverse(_.sortBy(blockModels, fb => _.get(fb, ["starsObtainedAt", 0])));

// get BAEDitor IDs of any instruction problems for a block
const getInstructionsBAEditorIDs = blockData => {
	let instructionsBAEditorIDs = [];
	blockData.instructions = _.reject(blockData.instructions, i => i.deletedAt);
	// Finding out what problems are necessary for the block instructions
	blockData.instructions.forEach(instruction => {
		let baeIDs = instruction.text.match(/\\pid{([0-9]+)}/g) || [];
		baeIDs = baeIDs.map(id => parseInt(/\\pid{([0-9]+)}/g.exec(id)[1]));
		instructionsBAEditorIDs = instructionsBAEditorIDs.concat(baeIDs);
	});
	return _.uniq(instructionsBAEditorIDs);
};

module.exports = {
	getBookTestHashFromName,
	getFinishedBlocks,
	getUnfinishedBlocks,
	isBlockComplete,
	sortUnfinishedHomework,
	sortFinishedHomework,
	getInstructionsBAEditorIDs,
};
